import type { ButtonHTMLAttributes, ReactNode } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  variant?: ButtonVariant;
  leftIcon?: ReactNode;
}

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    'bg-[var(--la-gold)] text-[var(--la-bg)] shadow-[0_0_30px_rgba(201,169,110,0.25)] hover:bg-[var(--la-lilith)]',
  secondary:
    'border border-[rgba(201,169,110,0.35)] bg-[rgba(128,0,64,0.24)] text-[var(--la-text)] hover:border-[var(--la-gold)]',
  ghost: 'bg-transparent text-[var(--la-text-muted)] hover:text-[var(--la-text)]',
};

export function Button({
  children,
  className = '',
  leftIcon,
  type = 'button',
  variant = 'primary',
  ...props
}: ButtonProps) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold transition ${variantClasses[variant]} ${className}`.trim()}
      type={type}
      {...props}
    >
      {leftIcon}
      <span>{children}</span>
    </button>
  );
}
